var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDac(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1607)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_69_1607",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.3999,
    y: 32.0312,
    width: 65.6,
    height: 96,
    rx: 4.8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.3999,
    y: 32.0312,
    width: 65.6,
    height: 96,
    rx: 4.8,
    stroke: "white",
    strokeWidth: 12.8,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-1_69_1607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 57.6312H124.8V102.431H129.6C136.669 102.431 142.4 96.7004 142.4 89.6312V70.4312C142.4 63.3619 136.669 57.6312 129.6 57.6312Z",
    stroke: "white",
    strokeWidth: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 60.3932V101.27C64 102.016 63.4837 102.663 62.7558 102.829L54.6303 104.683C51.9868 105.286 49.5011 106.441 47.3366 108.074L42.5636 111.675C41.5094 112.47 40 111.718 40 110.398V51.2651C40 49.9445 41.5094 49.1925 42.5636 49.9878L47.3366 53.5884C49.5011 55.2213 51.9868 56.3772 54.6303 56.9801L62.7558 58.8333C63.4837 58.9993 64 59.6466 64 60.3932Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 80.1562H-3.19995",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7316 64.2813L-2.33154 54.4312",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7316 96.1562L-2.33154 106.006",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.8 88.0312C116.8 87.1475 116.084 86.4312 115.2 86.4312H75.2001C74.3164 86.4312 73.6001 87.1475 73.6001 88.0312V115.231C73.6001 116.115 74.3164 116.831 75.2001 116.831H115.2C116.084 116.831 116.8 116.115 116.8 115.231V88.0312ZM88.7336 97.8168C89.0654 98.6321 88.3592 99.4165 87.479 99.4165H87.2703C86.6574 99.4165 86.1736 98.9407 85.8739 98.4061V98.4061C85.7088 98.1072 85.4969 97.8529 85.2382 97.6433C84.9795 97.4336 84.6806 97.273 84.3415 97.1615C84.0069 97.0499 83.6433 96.9942 83.2508 96.9942C82.5415 96.9942 81.9236 97.1704 81.3972 97.5228C80.8708 97.8708 80.4626 98.3793 80.1726 99.0485C79.8826 99.7132 79.7376 100.521 79.7376 101.471C79.7376 102.448 79.8826 103.269 80.1726 103.933C80.467 104.598 80.8775 105.1 81.4039 105.439C81.9303 105.778 82.5392 105.948 83.2307 105.948C83.6188 105.948 83.9779 105.896 84.3081 105.794C84.6426 105.691 84.9393 105.542 85.198 105.345C85.4568 105.145 85.6709 104.901 85.8404 104.616V104.616C86.1559 104.098 86.6432 103.641 87.2494 103.644L87.4541 103.645C88.3482 103.649 89.0481 104.449 88.6695 105.258C88.636 105.33 88.6008 105.401 88.564 105.473C88.2651 106.052 87.8613 106.572 87.3528 107.032C86.8487 107.487 86.2464 107.848 85.546 108.116C84.8501 108.379 84.0627 108.511 83.1839 108.511C81.9615 108.511 80.8685 108.234 79.9049 107.681C78.9458 107.128 78.1874 106.327 77.6298 105.278C77.0766 104.23 76.8 102.961 76.8 101.471C76.8 99.9764 77.0811 98.705 77.6432 97.6566C78.2053 96.6083 78.9681 95.8097 79.9317 95.261C80.8953 94.7078 81.9794 94.4313 83.1839 94.4313C83.9779 94.4313 84.714 94.5428 85.3921 94.7658C86.0747 94.9889 86.6791 95.3146 87.2055 95.7428C87.732 96.1666 88.1602 96.6863 88.4903 97.302C88.5801 97.4671 88.6612 97.6387 88.7336 97.8168ZM103.804 101.471C103.804 102.965 103.521 104.237 102.954 105.285C102.392 106.333 101.625 107.134 100.652 107.687C99.6844 108.236 98.5959 108.511 97.3869 108.511C96.169 108.511 95.0761 108.234 94.108 107.681C93.1399 107.128 92.3749 106.327 91.8128 105.278C91.2507 104.23 90.9696 102.961 90.9696 101.471C90.9696 99.9764 91.2507 98.705 91.8128 97.6566C92.3749 96.6083 93.1399 95.8097 94.108 95.261C95.0761 94.7078 96.169 94.4313 97.3869 94.4313C98.5959 94.4313 99.6844 94.7078 100.652 95.261C101.625 95.8097 102.392 96.6083 102.954 97.6566C103.521 98.705 103.804 99.9764 103.804 101.471ZM100.867 101.471C100.867 100.503 100.722 99.6864 100.432 99.0217C100.146 98.357 99.7424 97.8529 99.2204 97.5094C98.6985 97.1659 98.0873 96.9942 97.3869 96.9942C96.6865 96.9942 96.0754 97.1659 95.5534 97.5094C95.0315 97.8529 94.6255 98.357 94.3355 99.0217C94.05 99.6864 93.9073 100.503 93.9073 101.471C93.9073 102.439 94.05 103.255 94.3355 103.92C94.6255 104.585 95.0315 105.089 95.5534 105.432C96.0754 105.776 96.6865 105.948 97.3869 105.948C98.0873 105.948 98.6985 105.776 99.2204 105.432C99.7424 105.089 100.146 104.585 100.432 103.92C100.722 103.255 100.867 102.439 100.867 101.471ZM106.04 106.276C105.799 106.5 105.662 106.814 105.662 107.143V107.143C105.662 107.795 106.191 108.323 106.843 108.323H112.638C113.169 108.323 113.6 107.892 113.6 107.361V107.361C113.6 106.829 113.169 106.398 112.638 106.398H108.978C108.948 106.398 108.924 106.374 108.924 106.345V106.345C108.924 106.33 108.93 106.317 108.94 106.307L110.55 104.729C111.315 104.033 111.907 103.437 112.328 102.941C112.748 102.44 113.04 101.985 113.203 101.576C113.37 101.166 113.453 100.751 113.453 100.331C113.453 99.6892 113.288 99.1202 112.958 98.6236C112.629 98.127 112.166 97.7392 111.572 97.4601C110.981 97.1773 110.287 97.036 109.49 97.036C108.714 97.036 108.029 97.1828 107.434 97.4764C106.84 97.77 106.378 98.185 106.048 98.7214C105.898 98.966 105.782 99.2305 105.7 99.5149C105.529 100.108 106.053 100.619 106.671 100.619H106.836C107.362 100.619 107.747 100.163 107.994 99.7001V99.7001C108.132 99.4428 108.328 99.2452 108.582 99.1075C108.835 98.9697 109.133 98.9009 109.473 98.9009C109.8 98.9009 110.091 98.9661 110.349 99.0966C110.606 99.2235 110.809 99.4065 110.958 99.6457C111.106 99.8813 111.181 100.162 111.181 100.488C111.181 100.782 111.121 101.056 111.001 101.309C110.882 101.56 110.706 101.815 110.474 102.076C110.245 102.337 109.963 102.631 109.626 102.957L106.04 106.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1941 83.6196L27.5882 80.2255L24.1941 76.8314",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.957 99.3882L27.357 95.2313L23.2001 92.8313",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0332 67.4148L27.3835 65.3862L25.3549 61.036",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDac);
export default __webpack_public_path__ + "static/media/icon_dac.34ec96616a59d491559e625c9827e682.svg";
export { ForwardRef as ReactComponent };